export default __webpack_public_path__ + "static/media/786.295e5eaa.png";